import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { PRICING_PROFILE_DATE_RANGE_PATH } from '../../../../config/paths';
import DeletePricingProfileDateRangeButton from './DeletePricingProfileDateRangeButton';

const PricingProfileDateRangeToolbar = ({ pricingProfileDateRangeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${PRICING_PROFILE_DATE_RANGE_PATH}/${pricingProfileDateRangeId}/edit`}
      />{' '}
      <DeletePricingProfileDateRangeButton
        pricingProfileDateRangeId={pricingProfileDateRangeId}
      />
    </div>
  </ButtonToolbar>
);

PricingProfileDateRangeToolbar.propTypes = {
  pricingProfileDateRangeId: PropTypes.number.isRequired,
};

export default PricingProfileDateRangeToolbar;
